/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Research_WebInputs */



/**
* | output |
* | --- |
* | "Research topics with web search" |
*
* @param {Onboarding_Usage_Research_WebInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_research_web = /** @type {((inputs?: Onboarding_Usage_Research_WebInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Research_WebInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Themen mit Websuche recherchieren")
	return /** @type {LocalizedString} */ ("Research topics with web search")
});